import { Component, Input, Output, OnInit, TemplateRef, ViewChild, EventEmitter} from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../common/services/common.service';
import { GlobalConstants } from '../../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-delete-acknowledgement-dialog',
  templateUrl: './delete-acknowledgement-dialog.component.html',
  styleUrls: ['./delete-acknowledgement-dialog.component.scss']
})
export class DeleteAcknowledgementDialogComponent implements OnInit {
  @ViewChild('deleteAcknowlegeModal') private ackModalContent: TemplateRef<DeleteAcknowledgementDialogComponent>;
  @Input() sourceString: string;
  @Input() isStoreDeleteCnfrm: boolean;
  @Input() isMultiStoreDeleteCnfrm: boolean;
  @Input() isMultiSkuDelete: boolean;
  @Input() tabbIndex = [];
  @Input() deleteSelectedSkuText: string;
  @Input() isSystemIDDeleteCnfrm: boolean;
  @Input() isMultisystemIddelete: boolean;
  @Output() readonly delete = new EventEmitter();
  langDirection: string;
  globalConst = GlobalConstants;
  private ackModalRef: NgbModalRef;
  private ackModalOption: NgbModalOptions = {};
  constructor(private ackModalService: NgbModal,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.langDirection = this.commonService.direction;
  }

  open() {
    this.ackModalOption.backdrop = 'static';
    this.ackModalOption.keyboard = false;
    this.ackModalRef = this.ackModalService.open(this.ackModalContent, this.ackModalOption);
    this.ackModalRef.result.then().catch((res) => {});
  }

  dismissModal() {
    this.ackModalRef.dismiss();
    if(this.delete){
      this.delete.emit();
    }
  }

}
